import { AfterViewInit, Directive, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  selector: '[lazyImg]',
})
export class LazyImageDirective implements OnInit, AfterViewInit {

  private lazySrc: string | undefined;
  private observer: IntersectionObserver | undefined;
  private subject$ = new Subject<{
    entry: IntersectionObserverEntry;
    observer: IntersectionObserver;
  }>();

  constructor(
    private element: ElementRef<HTMLImageElement>,
    private renderer: Renderer2) {
  }

  ngOnInit() {
    const supports = 'loading' in HTMLImageElement.prototype;

    this.renderer.addClass(this.element.nativeElement, 'on-lazy-load');
    this.element.nativeElement.addEventListener('load', () => {
      this.renderer.removeClass(this.element.nativeElement, 'on-lazy-load');
    });

    if (supports) {
      this.element.nativeElement.setAttribute('loading', 'lazy');
    } else {
      this.lazySrc = this.element.nativeElement.src;
      this.renderer.removeAttribute(this.element.nativeElement, 'src');
      this.createObserver();
    }
  }

  ngAfterViewInit() {
    this.startObservingElements();
  }

  private createObserver() {
    const options = {
      rootMargin: '0px',
      threshold: 0.1
    };

    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          this.subject$.next({ entry, observer });
        }
      });
    }, options);
  }

  private startObservingElements() {
    if (!this.observer) {
      return;
    }

    this.observer.observe(this.element.nativeElement);

    this.subject$
      .subscribe(async ({ entry, observer }) => {
        const target = entry.target as HTMLElement;
        this.renderer.setProperty(this.element.nativeElement, 'src', this.lazySrc);

        observer.unobserve(target);
      });
  }
}
